import script from "./PageHeaderWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeaderWrapper.vue?vue&type=script&setup=true&lang=js"

import "./PageHeaderWrapper.vue?vue&type=style&index=0&id=bcad14d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcad14d2"]])

export default __exports__